import 'jquery/dist/jquery.min';
import 'jquery-ujs';